import { Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';
import * as staffActions from './staff.actions';
import * as staffSelectors from './staff.selectors';
import { StaffState } from './staff.reducer';

import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { OrgStaffUserInterface, OrgStaffUserInterfaceWithId } from '@sk/sk-interfaces';


@Injectable()
export class StaffFacade {
  staffLoaded$ = this.store.pipe(select(staffSelectors.getStaffLoaded));
  allStaff$ = this.store.pipe(select(staffSelectors.getAllStaff));
  allActiveStaff$ = this.store.pipe(select(staffSelectors.getActiveStaff));
  allActiveAndInvitedStaff$ = this.store.pipe(select(staffSelectors.getActiveAndInvitedStaff));
  allInvitedStaff$ = this.store.pipe(select(staffSelectors.getInvitedStaff));
  allInActiveStaff$ = this.store.pipe(select(staffSelectors.getInActiveStaff));
  allAdminAndMemberStaff$ = this.store.pipe(select(staffSelectors.getAdminAndMemberStaff));

  allClientOrganizationUsers$ = this.store.pipe(select(staffSelectors.getAllClientUsers));

  selectedStaff$ = this.store.pipe(select(staffSelectors.getSelected));
  allStaffDictionary$ = this.store.pipe(select(staffSelectors.getOrganizationUserEntities));


  addStaffErrors$ = this.store.pipe(select(staffSelectors.getAddStaffError));
  addStaffSuccess$ = this.store.pipe(select(staffSelectors.getAddStaffSuccess));

  updateStaffErrors$ = this.store.pipe(select(staffSelectors.getUpdateStaffError));
  updateStaffSuccess$ = this.store.pipe(select(staffSelectors.getUpdateStaffSuccess));

  staffQueryError$ = this.store.pipe(select(staffSelectors.getAddStaffError));


  constructor(private store: Store<StaffState>) {
  }


  loadStaffFromFirestore() {
    this.store.dispatch(staffActions.queryFireStoreStaff({}));
  }

  addStaff(staff: OrgStaffUserInterface) {
    const newStaff = {
      id : null,
      exists: false,
      ...staff
    }
    this.store.dispatch(staffActions.addStaff({
      staff: newStaff
    }));
  }

  updateStaff(staffId: string, changes: OrgStaffUserInterfaceWithId) {
    this.store.dispatch(staffActions.updateStaff({
      id: staffId,
      changes
    }));
  }

  getStaffById(id: string): Observable<OrgStaffUserInterfaceWithId> {
    return this.store.select(staffSelectors.getAllStaff)
      .pipe(
        map(list => list.find(item => item.id === id))
      );
  }


}
